export default __webpack_public_path__ + "static/media/logo.a783d0da.svg";